var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (caption, classes, continueBtnText, doneText, hasNarration, hasPrompt, i18n, isNumber, longestRow, prompt, rows, style, submitUp, title, undefined) {
buf.push("<div class=\"content-fit content-scroll content-ver text-center block-v-md\"><div class=\"content-scroll-inner block-v-md\"><h1 class=\"text-center fade-in\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"table-container\"><div class=\"table-wrapper\"><table" + (jade.cls(['table','slide-up',classes], [null,null,true])) + "><tbody>");
// iterate rows
;(function(){
  var $$obj = rows;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var row = $$obj[i];

buf.push("<tr class=\"table-row\">");
// iterate longestRow.cells
;(function(){
  var $$obj = longestRow.cells;
  if ('number' == typeof $$obj.length) {

    for (var col = 0, $$l = $$obj.length; col < $$l; col++) {
      var n = $$obj[col];

var el = row.cells[col] || ""
if ( style.header && i === 0)
{
buf.push("<th class=\"table-cell\">" + (null == (jade_interp = el) ? "" : jade_interp) + "</th>");
}
else
{
buf.push("<td" + (jade.attr("align", isNumber(el) && "right", true, false)) + " class=\"table-cell\"><div" + (jade.cls(['slide-up',"delay-" + (i) + ""], [null,true])) + ">" + (null == (jade_interp = el) ? "" : jade_interp) + "</div></td>");
}
    }

  } else {
    var $$l = 0;
    for (var col in $$obj) {
      $$l++;      var n = $$obj[col];

var el = row.cells[col] || ""
if ( style.header && i === 0)
{
buf.push("<th class=\"table-cell\">" + (null == (jade_interp = el) ? "" : jade_interp) + "</th>");
}
else
{
buf.push("<td" + (jade.attr("align", isNumber(el) && "right", true, false)) + " class=\"table-cell\"><div" + (jade.cls(['slide-up',"delay-" + (i) + ""], [null,true])) + ">" + (null == (jade_interp = el) ? "" : jade_interp) + "</div></td>");
}
    }

  }
}).call(this);

buf.push("</tr>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var row = $$obj[i];

buf.push("<tr class=\"table-row\">");
// iterate longestRow.cells
;(function(){
  var $$obj = longestRow.cells;
  if ('number' == typeof $$obj.length) {

    for (var col = 0, $$l = $$obj.length; col < $$l; col++) {
      var n = $$obj[col];

var el = row.cells[col] || ""
if ( style.header && i === 0)
{
buf.push("<th class=\"table-cell\">" + (null == (jade_interp = el) ? "" : jade_interp) + "</th>");
}
else
{
buf.push("<td" + (jade.attr("align", isNumber(el) && "right", true, false)) + " class=\"table-cell\"><div" + (jade.cls(['slide-up',"delay-" + (i) + ""], [null,true])) + ">" + (null == (jade_interp = el) ? "" : jade_interp) + "</div></td>");
}
    }

  } else {
    var $$l = 0;
    for (var col in $$obj) {
      $$l++;      var n = $$obj[col];

var el = row.cells[col] || ""
if ( style.header && i === 0)
{
buf.push("<th class=\"table-cell\">" + (null == (jade_interp = el) ? "" : jade_interp) + "</th>");
}
else
{
buf.push("<td" + (jade.attr("align", isNumber(el) && "right", true, false)) + " class=\"table-cell\"><div" + (jade.cls(['slide-up',"delay-" + (i) + ""], [null,true])) + ">" + (null == (jade_interp = el) ? "" : jade_interp) + "</div></td>");
}
    }

  }
}).call(this);

buf.push("</tr>");
    }

  }
}).call(this);

if ( caption)
{
buf.push("<tr class=\"table-row\"><td" + (jade.attr("colspan", longestRow.cells.length, true, false)) + " align=\"center\" class=\"table-cell\"><small>" + (null == (jade_interp = caption) ? "" : jade_interp) + "</small></td></tr>");
}
buf.push("</tbody></table></div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"caption" in locals_for_with?locals_for_with.caption:typeof caption!=="undefined"?caption:undefined,"classes" in locals_for_with?locals_for_with.classes:typeof classes!=="undefined"?classes:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"isNumber" in locals_for_with?locals_for_with.isNumber:typeof isNumber!=="undefined"?isNumber:undefined,"longestRow" in locals_for_with?locals_for_with.longestRow:typeof longestRow!=="undefined"?longestRow:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"rows" in locals_for_with?locals_for_with.rows:typeof rows!=="undefined"?rows:undefined,"style" in locals_for_with?locals_for_with.style:typeof style!=="undefined"?style:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}